// Layout
import Breadcrumbs from '@/components/ui/Breadcrumbs'

// Next
import RouterLink from '@/components/ui/RouterLink'

// Table
import WarrantyTable from '@/components/warranties/WarrantyTable'

// Mantine
import { Button } from '@mantine/core'

// Icons
import { Plus } from '@untitled-ui/icons-react'

export default function WarrantiesIndex() {
    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Garanties',
        },
    ]

    const rightSection = (
        <Button component={RouterLink} href="/warranties/associate" variant="light" color="dark" leftSection={<Plus width={14} height={14} />}>
            Associer une garantie
        </Button>
    )

    return (
        <div>
            <Breadcrumbs
                breadcrumbs={breadcrumbs}
                rightSection={rightSection}
            />
            <WarrantyTable />
        </div>
    )
}
